<template>
  <div :class="['select-regionId', routeName === 'Org' && 'is-flex']">
    <div class="select-regionId-header">
      <div class="select-regionId-header-username">{{ customerName }}</div>
      <SelectCom
        v-model="areaId"
        :options="agentRegionOption"
        @input="onAreaIdChange"
        :clearable="false"
        placeholder="请选择代理区域"
        size="large"
      />
    </div>
    <div
      :class="[
        'select-regionId-footer',
        routeName === 'OverallStat' && 'has-padding',
        routeName === 'Org' && 'flex-end',
      ]"
    >
      <div class="select-regionId-left" v-show="routeName !== 'Org'">
        <DateUnitAndPicker :areaId="areaId" @changeTimes="changeTimes" />
      </div>
      <div class="select-regionId-right">
        <div v-if="needShare" class="stat-share">
          <el-button type="primary" @click="statShare">数据分享</el-button>
          <el-tooltip class="item" effect="light" placement="top">
            <div slot="content">
              仅分享选择区域的大数据看板。<br />
              大数据看板为展示用途，不提供机构、收入数据
            </div>
            <i class="icon iconfont icon-help stat-share-help"></i>
          </el-tooltip>
        </div>
        <SelectCom
          v-model="countyId"
          :options="counties"
          size="large"
          placeholder="请选择区(县)"
          class="select-dom"
          width="23.5%"
          :disabled="!curAreaLevel || curAreaLevel >= 4"
          @input="onCountyIdChange"
        />
        <SelectCom
          v-model="cityId"
          :options="cities"
          size="large"
          placeholder="请选择市"
          class="select-dom"
          width="23.5%"
          :disabled="!curAreaLevel || curAreaLevel >= 3"
          @input="onCityIdChange"
        />
        <SelectCom
          v-model="stateId"
          :options="states"
          size="large"
          placeholder="请选择省"
          class="select-dom"
          width="23.5%"
          :disabled="!curAreaLevel || curAreaLevel >= 2"
          @input="onStateIdChange"
        />
        <div
          class="select-text"
          style="width: 60px; font-size: 14px; flex-shrink: 0"
        >
          区域选择
        </div>
      </div>
    </div>
    <el-dialog v-if="shareShow" :visible.sync="shareShow" width="450px">
      <div class="share-box">
        <div class="share-box-common">
          <img :src="require('@/assets/icon/private-link.png')" />
          <div class="share-box-right">
            <div class="share-box-right-type">
              <span>私密链接</span>
              <el-switch
                v-model="linkStatus"
                @input="linkStatusChange"
                active-text="开启"
                inactive-text="关闭"
              >
              </el-switch>
            </div>
            <div class="share-box-right-tip">
              将数据看板通过下面的链接分享给没有账号的人。
            </div>
            <div class="share-box-right-btn">
              <div>
                <span>分享码</span>
                <span
                  :class="['share-code', !linkStatus && 'share-code-disable']"
                  >{{ shareCode }}</span
                >
              </div>
              <el-button
                type="primary"
                size="medium"
                :disabled="!linkStatus"
                @click="copyLink"
                >分享</el-button
              >
            </div>
            <el-input :disabled="!linkStatus" :value="privateLink"></el-input>
            <div class="share-box-admin">
              我是管理员，
              <span @click="openStat">直接查看</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import SelectCom from './SelectCom'
import md5 from 'md5'
import { randomStr } from '@/utils/common'
import constant from '@/utils/constant'
import DateUnitAndPicker from './DateUnitAndPicker'

export default {
  name: 'SelectRegionId',
  props: {
    value: [String, Number],
    needShare: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SelectCom,
    DateUnitAndPicker,
  },
  data() {
    return {
      regionId: '',
      areaId: '',
      stateId: '',
      cityId: '',
      countyId: '',
      states: [],
      cities: [],
      counties: [],
      shareShow: false,
      linkStatus: true,
      shareDetail: {},
    }
  },
  computed: {
    ...mapGetters({
      userDetail: 'customer/userDetail',
    }),
    routeName() {
      return this.$route.name || 'OverallStat'
    },
    privateLink() {
      return `${location.origin}/#/share/${this.shareDetail.sid}`
    },
    shareCode() {
      return this.shareDetail.passcode
    },
    customerName() {
      return _.get(this.userDetail, 'username')
    },
    agentId() {
      return _.get(this.userDetail, 'agent.id')
    },
    agentAreas() {
      return _.get(this.userDetail, 'agentAreas', [])
    },
    agentRegions() {
      return _.get(this.userDetail, 'agentRegions', [])
    },
    curArea() {
      return (
        this.agentRegionOption.find(item => item.value === this.areaId) || {}
      )
    },
    curAreaLevel() {
      return this.curArea.level
    },
    agentRegionOption() {
      return this.agentRegions.map(item => {
        const curArea = this.agentAreas.find(area => area.regionId === item.id)
        let label = item.fullname
        return {
          value: curArea.id,
          label,
          level: item.level,
          regionId: curArea.regionId,
        }
      })
    },
    formatStartAt() {
      let startAt = constant.startDate
      if (this.areaId) {
        const curArea = _.find(this.agentAreas, item => item.id === this.areaId)
        if (moment(curArea.beginAt) > moment(startAt)) {
          startAt = curArea.beginAt
        }
      }
      return moment(startAt).format('YYYY-MM-DD')
    },
    yesterdayDate() {
      return moment().subtract(1, 'days').format('YYYY-MM-DD')
    },
  },
  created() {
    const sortList = _.cloneDeep(this.agentAreas)
    sortList.sort((pre, next) =>
      moment(next.endAt).diff(moment(pre.endAt), 'minutes')
    )
    this.init(_.get(sortList, '0.regionId', ''))
  },
  watch: {
    regionId(regionId) {
      this.$emit('input', regionId)
    },
    areaId(areaId) {
      this.$emit('changeAreaId', areaId)
    },
  },
  methods: {
    ...mapActions({
      getChildrenArea: 'agent/getChildrenArea',
      getRegionDetail: 'agent/getRegionDetail',
      getAndCreateShare: 'newStat/getAndCreateShare',
      updateAgentShare: 'newStat/updateAgentShare',
    }),
    async statShare() {
      const data = {
        agentId: this.agentId,
        regionId: this.regionId,
        customerName: this.customerName,
      }
      const sid = md5(JSON.stringify(data))
      const shareDetail = await this.getAndCreateShare({
        sid,
        isPublic: 0,
        status: 1,
        data,
        passcode: randomStr(6),
      })
      this.linkStatus = shareDetail.status ? true : false
      this.shareDetail = shareDetail
      this.shareShow = true
    },
    copyLink() {
      this.$copyText(
        `链接：${this.privateLink}
      分享码：${this.shareCode}
      复制链接使用浏览器打开，并输入分享码即可查看内容`
      )
        .then(() => {
          this.$message.success('复制成功')
        })
        .catch(() => {
          this.$message.error('复制失败')
        })
    },
    openStat() {
      window.open(`${this.privateLink}&${this.regionId}`)
    },
    async linkStatusChange() {
      const data = {
        ...this.shareDetail,
        status: this.linkStatus ? 1 : 0,
      }
      if (this.linkStatus) {
        data.passcode = randomStr(6)
      }
      await this.updateAgentShare(data)
      await this.statShare()
    },
    async init(regionId) {
      this.regionId = regionId
      const curArea = this.agentAreas.find(item => item.regionId === regionId)
      if (curArea) {
        this.areaId = curArea.id
      }
      if (regionId) {
        this.states = await this.formatRegions(1)
        const regionDetail = await this.getRegionDetail(regionId)
        const { info = {}, level } = regionDetail
        const { state = {}, city = {}, county = {} } = info
        this.stateId = state.id
        if (level >= 2) {
          this.cities = await this.formatRegions(state.id)
        }
        if (level >= 3) {
          this.cityId = city.id
          this.counties = await this.formatRegions(city.id)
        }
        if (level >= 4) {
          this.countyId = county.id
        }
      }
    },
    onAreaIdChange(areaId) {
      this.stateId = ''
      this.cityId = ''
      this.countyId = ''
      this.states = []
      this.cities = []
      this.counties = []
      const curArea = this.agentAreas.find(item => item.id === areaId)
      this.init(curArea.regionId)
    },
    async onStateIdChange(stateId) {
      this.cityId = ''
      this.countyId = ''
      this.cities = []
      this.counties = []
      if (stateId) {
        this.regionId = stateId
        this.cities = await this.formatRegions(stateId)
      } else {
        this.regionId = this.curArea && this.curArea.regionId
      }
    },
    async onCityIdChange(cityId) {
      this.countyId = ''
      this.counties = []
      if (cityId) {
        this.regionId = cityId
        this.counties = await this.formatRegions(cityId)
      } else {
        this.regionId = this.stateId
      }
    },
    async onCountyIdChange(countyId) {
      if (countyId) {
        this.regionId = countyId
      } else {
        this.regionId = this.cityId
      }
    },
    async formatRegions(regionId) {
      const regions = await this.getChildrenArea(regionId)
      return _.map(regions, item => {
        return {
          label: item.name,
          value: item.id,
        }
      })
    },
    changeTimes(params) {
      this.$emit('changeTimes', params)
    },
  },
}
</script>

<style lang='scss'>
.select-regionId {
  .select-regionId-header {
    display: flex;
    align-items: center;
    width: 300px;
    background: rgb(245, 245, 245);
    padding-bottom: 20px;
    .select-regionId-header-username {
      color: #333333;
      font-size: 20px;
      line-height: 20px;
      margin-right: 16px;
    }
  }
  .select-regionId-footer {
    display: flex;
    justify-content: space-between;
  }
  .has-padding {
    padding: 28px 40px 0px 28px;
  }
  .flex-end {
    justify-content: flex-end;
    .select-regionId-right {
      width: 100%;
      align-items: flex-start;
      .select-text {
        position: relative;
        top: 12px;
      }
    }
  }
  .select-regionId-left {
    width: 40%;
  }
  .select-regionId-right {
    display: flex;
    align-items: center;
    width: 52%;
    flex-direction: row-reverse;
    font-size: 14px;
    .select-dom {
      margin-left: 8px;
    }
    .stat-share {
      position: relative;
      margin-left: 10px;
      .stat-share-help {
        color: #2397f3;
        font-size: 14px;
        position: absolute;
        right: -14px;
        top: -14px;
        cursor: help;
      }
    }
  }
  .share-box {
    margin-left: 34px;
    margin-top: -10px;
    .share-box-common {
      position: relative;
      font-size: 14px;
      color: #aaaaaa;
      & > img {
        position: absolute;
        left: -26px;
        top: 0px;
      }
      .share-box-right-type {
        color: #333;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
      }
      .share-box-right-tip {
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .share-code {
        background: #eeeeee;
        color: #333;
        padding: 10px 16px;
        border-radius: 4px;
        margin-left: 14px;
      }
      .share-code-disable {
        opacity: 0.4;
      }
      .share-box-right-btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 16px;
        margin-bottom: 16px;
      }
      .el-button {
        padding: 10px 30px;
      }
      .share-box-admin {
        margin-top: 14px;
        span {
          color: #2397f3;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}
.is-flex {
  display: flex;
  justify-content: space-between;
}
</style>